module.exports = __webpack_public_path__ + "media/music/a0b130dbafdc7958b73d162239053173.mp3";